import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Switch, TextBox } from '@progress/kendo-react-inputs';
import { useState } from 'react';
import { WarningTriangleOutline } from '../../../../../icons/icons';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';
import { useFormStringValue } from '../../../home/hooks/forms';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsAutoLoginElement() {
    const context = useSearchContext();
    const enabled = useAppSelector((x) => x.settings.autoLogin);
    const autoLoginPassword = useAppSelector((x) => x.settings.autoLoginPassword);
    const [credentialsPopup, setCredentialsPopup] = useState(false);
    const dispatch = useAppDispatch();

    return (
        <div className="d-flex gap-2 px-3 align-items-center">
            <div className="flex-grow-1">
                <MarkerText highlight={context.term}>Automatic login</MarkerText>
                {enabled && (
                    <div className="d-flex flex-row align-items-center text-warning">
                        <SvgIcon icon={WarningTriangleOutline} />
                        <span>Your credentials will be stored locally in the browser</span>
                    </div>
                )}
            </div>
            {credentialsPopup && <ChangeCredentialsPopup onClose={() => setCredentialsPopup(false)} />}
            {enabled && <Button onClick={() => setCredentialsPopup(true)}>Change password</Button>}
            <Switch
                checked={enabled}
                onChange={(e) => {
                    dispatch(setSetting('autoLogin', e.value));
                    if (e.value) {
                        if (!autoLoginPassword) {
                            setCredentialsPopup(true);
                        }
                    } else {
                        if (autoLoginPassword) {
                            dispatch(setSetting('autoLoginPassword', null));
                        }
                    }
                }}
            />
        </div>
    );
}

export function ChangeCredentialsPopup(props: { onClose?: () => void }) {
    const dispatch = useAppDispatch();
    const password = useFormStringValue('');

    return (
        <Dialog title="Set auto login password" onClose={props.onClose} width={'min(350px, 100vw)'}>
            <TextBox type="password" placeholder="Password" {...password} />
            <DialogActionsBar>
                <Button
                    themeColor="primary"
                    onClick={() => {
                        dispatch(setSetting('autoLoginPassword', btoa(password.value)));
                        props.onClose?.();
                    }}
                    disabled={!password.value}>
                    Save
                </Button>
                <Button onClick={props.onClose}>Cancel</Button>
            </DialogActionsBar>
        </Dialog>
    );
}
